module.exports = __webpack_public_path__ + "img/Outdoorsman.6018e817.png";